var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "w-full relative border border-gray-300 bg-white p-3 rounded shadow flex flex-col" };
const _hoisted_2 = {
    key: 0,
    class: "flex-grow flex items-center justify-center pt-6 pb-6"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "self-stretch justify-between items-start inline-flex mb-2" };
const _hoisted_5 = {
    class: "self-stretch text-gray-500 text-base font-normal font-['Inter'] leading-normal overflow-auto",
    style: { "max-height": "200px" }
};
const _hoisted_6 = { class: "flex justify-between items-center mt-2 mb-3" };
const _hoisted_7 = {
    key: 0,
    class: "flex mt-1"
};
const _hoisted_8 = { class: "mr-3" };
const _hoisted_9 = {
    key: 0,
    class: "w-full h-auto bg-blue-100 p-3 mb-3 rounded"
};
const _hoisted_10 = { class: "text-gray-500 text-xs font-medium font-['Inter']" };
const _hoisted_11 = { class: "flex items-center flex-wrap" };
const _hoisted_12 = { class: "border-t pt-2" };
const _hoisted_13 = { class: "flex justify-between" };
import { useNotification } from '@/compositions/useNotification';
import { PENDO_MODULE_EVENT_NAME } from '@/helper/const';
import { i18n } from '@/locales';
import { ContentAIServices } from '@/service/ContentAIService';
import { ContextualTypeKeys, QuickActionSubmitOptions, } from '@/types';
import { ArrowsLeftIcon, ArrowsRightIcon, ChevronLeftIcon, ChevronRightIcon, Edit04Icon, FeatherIcon, RefreshCcw02Icon, Type02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIModal, UIModalContent, UIModalHeader, UISpin, UITag, } from '@gohighlevel/ghl-ui';
import { computed, h, inject, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalQuickActionVariations',
    props: {
        showModal: {
            type: Boolean,
            default: false,
            required: false,
        },
        productType: {
            type: String,
            required: true,
        },
        subType: {
            type: String,
            required: false,
        },
        sessionId: {
            type: String,
            default: '',
            required: false,
        },
        selectedText: {
            type: String,
            default: '',
            required: false,
        },
        contextualType: {
            type: String,
            required: false,
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'updateSessionId'],
    setup(__props, { emit }) {
        const props = __props;
        const route = inject('route');
        const user = inject('user');
        const emitter = inject('emitter');
        const notification = useNotification();
        const submitLoading = ref(false);
        const variationLoading = ref(false);
        const loading = computed(() => variationLoading.value || submitLoading.value);
        const contextualAiSession = ref(props.sessionId);
        const variations = ref([]);
        const currentVariation = ref(0);
        const show = computed(() => props.showModal);
        const submittingButton = ref();
        const contextualLabel = computed(() => {
            const variation = variations.value[currentVariation.value];
            if (variation && variation.contextualType) {
                const option = quickActionOptions.find(o => o.key === variation.contextualType);
                return option ? option.label : '';
            }
            return '';
        });
        watch(show, (showModal) => __awaiter(this, void 0, void 0, function* () {
            if (showModal && !props.sessionId) {
                yield createQuickActionVariation();
            }
            else if (props.sessionId) {
                yield fetchVariationsForSession(props.sessionId);
            }
        }));
        function fetchVariationsForSession(sessionId) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (loading.value)
                        return;
                    variationLoading.value = true;
                    const { data } = yield ContentAIServices.getQuickActionSession(sessionId);
                    variations.value = [];
                    currentVariation.value = 0;
                    (_a = data === null || data === void 0 ? void 0 : data.contextualPosts) === null || _a === void 0 ? void 0 : _a.forEach((post, index) => {
                        var _a, _b;
                        variations.value.push({
                            response: (_a = post.variations[0]) === null || _a === void 0 ? void 0 : _a.response,
                            contextualType: post.contextualType,
                        });
                        if (post._id === ((_b = data === null || data === void 0 ? void 0 : data.session) === null || _b === void 0 ? void 0 : _b.contentUsed)) {
                            currentVariation.value = index;
                        }
                    });
                }
                catch (error) {
                    console.error(error);
                    showErrorNotification(error);
                }
                finally {
                    variationLoading.value = false;
                }
            });
        }
        function createQuickActionVariation(contextualType) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (loading.value)
                        return;
                    variationLoading.value = true;
                    let selectedText = props.selectedText;
                    if ((_a = variations.value) === null || _a === void 0 ? void 0 : _a.length)
                        selectedText = (_b = variations.value[currentVariation.value]) === null || _b === void 0 ? void 0 : _b.response;
                    const body = {
                        selectedText,
                        locationId: (_c = route === null || route === void 0 ? void 0 : route.params) === null || _c === void 0 ? void 0 : _c.location_id,
                        type: props.productType,
                        subType: props.subType,
                        userId: user === null || user === void 0 ? void 0 : user.id,
                        contextualType: contextualType || props.contextualType,
                        contextualId: contextualAiSession.value || null,
                    };
                    const { data } = yield ContentAIServices.generateQuickAction(body);
                    contextualAiSession.value = data.contextualAiSession;
                    if ((_d = data === null || data === void 0 ? void 0 : data.variations) === null || _d === void 0 ? void 0 : _d.length) {
                        variations.value.push({
                            response: data.variations[0].response,
                            contextualType: data.contextualType,
                            id: data.id,
                        });
                        currentVariation.value = variations.value.length - 1;
                    }
                    emitter.emit('pendo-track-event-content-ai', {
                        event: 'Quick Action ' + PENDO_MODULE_EVENT_NAME[props.productType],
                        properties: {
                            selectedText,
                            contextualType: contextualType || props.contextualType,
                            locationId: (_e = route === null || route === void 0 ? void 0 : route.params) === null || _e === void 0 ? void 0 : _e.location_id,
                        },
                    });
                }
                catch (error) {
                    console.error(error);
                    showErrorNotification(error);
                }
                finally {
                    variationLoading.value = false;
                }
            });
        }
        function submit(submitType) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (loading.value && !contextualAiSession.value)
                        return;
                    submitLoading.value = true;
                    submittingButton.value = submitType;
                    const { data } = yield ContentAIServices.updateQuickActionUsed(contextualAiSession.value, { contentUsedId: (_a = variations.value[currentVariation.value]) === null || _a === void 0 ? void 0 : _a.id });
                    if (data) {
                        emit('updateSessionId', {
                            submitType,
                            quickActionSessionId: contextualAiSession.value,
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                    showErrorNotification(error);
                }
                finally {
                    submitLoading.value = false;
                    closeModal();
                }
            });
        }
        function showErrorNotification(error) {
            var _a, _b;
            const errorMsg = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            if (errorMsg)
                notification.create({
                    type: 'error',
                    title: errorMsg,
                });
        }
        const quickActionOptions = [
            {
                label: i18n.global.t('modalQuickActionVariations.improveWriting'),
                key: ContextualTypeKeys.IMPROVE_WRITING,
                icon() {
                    return h(Edit04Icon);
                },
            },
            {
                label: i18n.global.t('modalQuickActionVariations.fixSpelling'),
                key: ContextualTypeKeys.FIX_SPELLING_GRAMMAR,
                icon() {
                    return h(Type02Icon);
                },
            },
            {
                label: i18n.global.t('modalQuickActionVariations.simplifyWriting'),
                key: ContextualTypeKeys.SIMPLIFY_WRITING,
                icon() {
                    return h(FeatherIcon);
                },
            },
            {
                label: i18n.global.t('modalQuickActionVariations.makeLonger'),
                key: ContextualTypeKeys.MAKE_LONGER,
                icon() {
                    return h(ArrowsRightIcon);
                },
            },
            {
                label: i18n.global.t('modalQuickActionVariations.makeShorter'),
                key: ContextualTypeKeys.MAKE_SHORTER,
                icon() {
                    return h(ArrowsLeftIcon);
                },
            },
        ];
        function resetModal() {
            currentVariation.value = 0;
            variations.value = [];
            contextualAiSession.value = null;
        }
        function closeModal() {
            if (submitLoading.value)
                return;
            resetModal();
            emit('close');
        }
        function emitCloseModal() {
            emit('updateSessionId', {
                submitType: QuickActionSubmitOptions.CLOSE,
            });
            closeModal();
        }
        const modalIcon = () => h('img', {
            src: 'https://storage.googleapis.com/crm-conversations-ai-staging/icon-contentai-gradient.svg',
            class: 'w-5 h-5',
        });
        function previousVariation() {
            if (currentVariation.value > 0 && !loading.value) {
                currentVariation.value--;
            }
        }
        function nextVariation() {
            var _a;
            if (currentVariation.value < ((_a = variations.value) === null || _a === void 0 ? void 0 : _a.length) - 1 && !loading.value) {
                currentVariation.value++;
            }
        }
        function regenerateSession() {
            return __awaiter(this, void 0, void 0, function* () {
                resetModal();
                yield createQuickActionVariation();
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: _unref(show),
                width: 640
            }, _createSlots({
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "quick-action-modal-header",
                        title: _ctx.$t('modalQuickActionVariations.title'),
                        icon: modalIcon,
                        type: "custom",
                        onClose: emitCloseModal
                    }, null, 8 /* PROPS */, ["title"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), { id: "quick-action-modal-content" }, {
                        default: _withCtx(() => {
                            var _a, _b, _c;
                            return [
                                _createElementVNode("div", _hoisted_1, [
                                    (variationLoading.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                            _createVNode(_unref(UISpin))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createVNode(_unref(UITag), {
                                                    size: "small",
                                                    bordered: false,
                                                    class: "text-center text-slate-700 text-xs font-medium font-['Inter']"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(contextualLabel)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_5, _toDisplayString((_a = variations.value[currentVariation.value]) === null || _a === void 0 ? void 0 : _a.response), 1 /* TEXT */)
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    ((_b = variations.value) === null || _b === void 0 ? void 0 : _b.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createVNode(_unref(ChevronLeftIcon), {
                                                onClick: previousVariation,
                                                class: _normalizeClass([
                                                    'w-5',
                                                    'h-5',
                                                    'mr-3',
                                                    currentVariation.value === 0 || _unref(loading)
                                                        ? 'cursor-not-allowed text-gray-300'
                                                        : 'cursor-pointer',
                                                ])
                                            }, null, 8 /* PROPS */, ["class"]),
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(currentVariation.value + 1) + " of " + _toDisplayString((_c = variations.value) === null || _c === void 0 ? void 0 : _c.length), 1 /* TEXT */),
                                            _createVNode(_unref(ChevronRightIcon), {
                                                onClick: nextVariation,
                                                class: _normalizeClass([
                                                    'w-5',
                                                    'h-5',
                                                    'mr-3',
                                                    currentVariation.value === variations.value.length - 1 || _unref(loading)
                                                        ? 'cursor-not-allowed text-gray-300'
                                                        : 'cursor-pointer',
                                                ])
                                            }, null, 8 /* PROPS */, ["class"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (!__props.hideControls)
                                        ? (_openBlock(), _createBlock(_unref(UIButton), {
                                            key: 1,
                                            id: "quick-action-regenerate-content-btn",
                                            type: "tertiary",
                                            size: "small",
                                            onClick: regenerateSession,
                                            class: "ml-auto",
                                            disabled: _unref(loading)
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(RefreshCcw02Icon), { class: "mr-2 w-4 h-4" }),
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('modalQuickActionVariations.regenerate')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                (!__props.hideControls)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('modalQuickActionVariations.selectQuickActionTitle')), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_11, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickActionOptions, (option) => {
                                                return _createElementVNode("div", {
                                                    key: option.key,
                                                    class: "mr-2 mt-2"
                                                }, [
                                                    (option.label)
                                                        ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                            key: 0,
                                                            id: "quick-action-option-btn",
                                                            size: "small",
                                                            onClick: ($event) => (createQuickActionVariation(option.key)),
                                                            disabled: _unref(loading)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (option.icon)
                                                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
                                                                        key: 0,
                                                                        class: "text-black w-5 h-5 mr-2"
                                                                    }))
                                                                    : _createCommentVNode("v-if", true),
                                                                _createTextVNode(" " + _toDisplayString(option.label), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "disabled"]))
                                                        : _createCommentVNode("v-if", true)
                                                ]);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (!__props.hideControls)
                    ? {
                        name: "footer",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_unref(UIButton), {
                                        id: "quick-action-cancel-modal",
                                        disabled: submitLoading.value,
                                        onClick: emitCloseModal
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('showVariationsModal.cancel')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"]),
                                    _createElementVNode("div", null, [
                                        _createVNode(_unref(UIButton), {
                                            id: "quick-action-add-below-btn",
                                            type: "tertiary",
                                            class: "mr-3",
                                            disabled: _unref(loading),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (submit(_unref(QuickActionSubmitOptions).ADD_BELOW))),
                                            loading: submitLoading.value &&
                                                submittingButton.value === _unref(QuickActionSubmitOptions).ADD_BELOW
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('modalQuickActionVariations.addBelow')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled", "loading"]),
                                        _createVNode(_unref(UIButton), {
                                            loading: submitLoading.value &&
                                                submittingButton.value === _unref(QuickActionSubmitOptions).REPLACE,
                                            id: "quick-action-replace-text-btn",
                                            type: "primary",
                                            disabled: _unref(loading),
                                            onClick: _cache[1] || (_cache[1] = ($event) => (submit(_unref(QuickActionSubmitOptions).REPLACE)))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('modalQuickActionVariations.replaceText')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["loading", "disabled"])
                                    ])
                                ])
                            ])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"]));
        };
    }
});
